import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Persistent in-app reminder of the mandatory AI estimation disclaimer.
 * Mirrors Section 3 of the Terms of Service.
 */
export function AIDisclaimerBanner({ variant = 'estimate', className = '' }) {
    const config = {
        estimate: {
            icon: AlertTriangle,
            iconColor: 'text-amber-600',
            bg: 'bg-amber-50',
            border: 'border-amber-200',
            title: 'AI estimate — not a binding quote',
            body: 'All AI-generated measurements, materials, and prices are unverified estimates. You must perform an independent on-site inspection and verify all numbers before signing any contract with a homeowner. See Terms §3.',
        },
    };
    const c = config[variant] || config.estimate;
    const Icon = c.icon;
    return (
        <div
            data-testid={`ai-disclaimer-${variant}`}
            className={`flex items-start gap-3 p-3 rounded-lg border ${c.bg} ${c.border} ${className}`}
            role="note"
        >
            <Icon className={`h-4 w-4 mt-0.5 shrink-0 ${c.iconColor}`} strokeWidth={2} />
            <div className="text-xs text-slate-700 leading-relaxed">
                <div className="font-semibold text-slate-900">{c.title}</div>
                <p className="mt-0.5">{c.body}</p>
            </div>
        </div>
    );
}
